import { Field, FieldFooter } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { LocationPicker } from 'components';
import { ILocationPickerValue } from 'types/Location';

interface ILocationPickerFormFieldProps {
  className?: string | object;
  form: any;
  name: string;
  initialAddress?: string;
  onChange?: (value: string | null) => void;
  validations?: any;
  autofocus?: boolean;
}

function LocationPickerFormField(props: ILocationPickerFormFieldProps) {
  const { form, name, validations, className, onChange, ...other } = props;

  const classes = classNames(
    {
      'location-picker-form-field': true,
    },
    className
  );

  function renderField({ ...fieldProps }) {
    function handleLocationChange(val: ILocationPickerValue | null) {
      fieldProps.handleChange(val, onChange);
    }

    const value = form.state.data[name] || null;
    const location = value ? value.location : null;
    const radius = value ? value.locationRadius : null;

    return (
      <>
        <LocationPicker
          error={fieldProps.hasError}
          location={location}
          radius={radius}
          onLocationChange={handleLocationChange}
          {...other}
        />
        <FieldFooter errorMessage={fieldProps.errorMessage} hasError={fieldProps.hasError} />
      </>
    );
  }

  return <Field form={form} name={name} validations={validations} className={classes} render={renderField} />;
}

export default LocationPickerFormField;
